<template>
  <v-main class="berkah-main">
    <div id="dashboard-core-view">
      <router-view />
    </div>
    </v-main>
</template>

<script>
  export default {
    name: 'DashboardCoreView',
  }
</script>

<style scoped>
.berkah-main {
  background: #f4f7f6;
}
</style>